var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m456 0h-400c-8.284 0-15 6.716-15 15v241c0 8.284 6.716 15 15 15h185v34h-17c-8.284 0-15 6.716-15 15v145c0 25.916 21.084 47 47 47s47-21.084 47-47v-145c0-8.284-6.716-15-15-15h-17v-34h185c8.284 0 15-6.716 15-15v-241c0-8.284-6.716-15-15-15zm-295.076 206.865c-11.88 0-38.885.135-40.924.135-8.292 0-15-6.728-15-15 0-11.569 0-107.302 0-120 0-8.284 6.716-15 15-15h35.141c30.581 0 58.333 36.553 35.377 67.314 10.009 8.7 16.482 21.583 16.482 35.686 0 25.403-21.1 46.865-46.076 46.865zm110.076-14.865c0 8.284-6.716 15-15 15s-15-6.716-15-15v-120c0-8.284 6.716-15 15-15s15 6.716 15 15zm128.167-27.042c-12.77 25.54-39.871 42.042-69.043 42.042h-10.124c-8.284 0-15-6.716-15-15v-120c0-8.284 6.716-15 15-15h10.124c56.15 0 94.167 57.708 69.043 107.958z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169 100c0-5.953-7.512-13-13.859-13h-20.141v25.941c7.844-.029 16.53-.057 20.141-.057 6.476 0 13.859-6.863 13.859-12.884z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.924 143h-25.924v33.941c9.726-.037 21.382-.076 25.924-.076 8.414 0 16.076-8.038 16.076-16.865 0-8.897-7.663-17-16.076-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335 87.248v89.505c15.991-1.627 30.309-11.16 37.333-25.211 14.054-28.104-5.061-61.011-37.333-64.294z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidIcon);
export default __webpack_public_path__ + "static/media/bid_icon.b1e523d7.svg";
export { ForwardRef as ReactComponent };